/**
 * Company: SPHMedia
 * Description: This is the base page component for all BH Quick News pages
 */

import CASBlock from "@components/Blocks/CASBlock/CASBlock";
import { CAS_EI_MODEL_ID } from "@helper/getEnvVariables";
import { useNeuronPageViewPush } from "@hooks/useAnalyticsCall/useNeuronPageViewPush";
import useGlobalAdSetting from "@hooks/useGlobalAdSetting";
import { useHideInvisibleAds } from "@hooks/useHideInvisibleAds";
import useHidePrestitialOverlay from "@hooks/useHidePrestitialOverlay";
import { ReactElement } from "react";

export type BHQuickNewsBasePageProps = {
  children?: React.ReactNode;
};

/**
 * BHQuickNewsBasePage
 * Description: The base page component for all BH Quick News pages
 * @param props - The props required by the component (if any)
 * @returns The rendered React element
 */
export default function BHQuickNewsBasePage({
  children,
}: BHQuickNewsBasePageProps): ReactElement {
  useGlobalAdSetting();
  useNeuronPageViewPush();
  useHideInvisibleAds();
  useHidePrestitialOverlay();

  return (
    <>
      <div className="max-w-screen relative mx-auto flex h-svh w-screen flex-col overflow-hidden bg-[linear-gradient(168deg,#272727_0%,#101010_100%)] blur-0">
        {children}
      </div>
      <CASBlock casId={CAS_EI_MODEL_ID} />
    </>
  );
}
